(() => {

    "use strict";

    //==================================================
    // CONFIG
    //==================================================

    const CONFIG = {

        TITLE: "🔥 Trending Collections",

        MAX_ITEMS: 8

    };



    //==================================================
    // STATE
    //==================================================

    let dropdown = null;

    let activeInput = null;



    //==================================================
    // HELPERS
    //==================================================

    function getCollections() {

        if (!Array.isArray(window.ANKUR_COLLECTION_DATA)) {

            console.warn(
                "ANKUR_COLLECTION_DATA not found."
            );

            return [];

        }

        return window.ANKUR_COLLECTION_DATA.slice(
            0,
            CONFIG.MAX_ITEMS
        );

    }



    function formatCount(count) {

        const number = Number(count) || 0;

        return number.toLocaleString() + " Products";

    }



    //==================================================
    // CREATE DROPDOWN
    //==================================================

    function createDropdown() {

        if (dropdown) return dropdown;

        dropdown = document.createElement("div");

        dropdown.className = "ankur-search-dropdown";



        dropdown.innerHTML = `

            <div class="ankur-search-dropdown__header">

                ${CONFIG.TITLE}

            </div>

            <div class="ankur-search-dropdown__body">

            </div>

        `;



        document.body.appendChild(dropdown);

        return dropdown;

    }



    //==================================================
    // RENDER COLLECTIONS
    //==================================================

    function renderCollections() {

        const body = dropdown.querySelector(
            ".ankur-search-dropdown__body"
        );

        body.innerHTML = "";



        getCollections().forEach(item => {

            const row = document.createElement("a");

            row.className =
                "ankur-search-dropdown__item";

            row.href = item.url;



            row.innerHTML = `

                <div class="ankur-search-dropdown__image">

                    <img
                        src="${item.image}"
                        loading="lazy"
                        alt="${item.title}"
                    >

                </div>

                <div class="ankur-search-dropdown__content">

                    <div class="ankur-search-dropdown__title">

                        ${item.badge ? item.badge + " " : ""}

                        ${item.title}

                    </div>

                    <div class="ankur-search-dropdown__count">

                        ${formatCount(item.count)}

                    </div>

                </div>

            `;



            body.appendChild(row);

        });

    }

    //==================================================
    // POSITION DROPDOWN
    //==================================================

    function positionDropdown(input) {

        if (!dropdown || !input) return;

        const rect = input.getBoundingClientRect();

        dropdown.style.position = "absolute";

        dropdown.style.left =
            (window.scrollX + rect.left) + "px";

        dropdown.style.top =
            (window.scrollY + rect.bottom + 8) + "px";

        dropdown.style.width =
            rect.width + "px";

    }



    //==================================================
    // SHOW
    //==================================================

    function showDropdown(input) {

        if (!dropdown) return;

        activeInput = input;

        positionDropdown(input);

        dropdown.style.display = "block";

    }

    //==================================================
    // HIDE
    //==================================================

    function hideDropdown() {

        if (!dropdown) return;

        dropdown.style.display = "none";

    }

    //==================================================
    // KEEP POSITION UPDATED
    //==================================================

    window.addEventListener("resize", () => {

        if (dropdown &&
            dropdown.style.display === "block" &&
            activeInput) {

            positionDropdown(activeInput);

        }

    });



    window.addEventListener("scroll", () => {

        if (dropdown &&
            dropdown.style.display === "block" &&
            activeInput) {

            positionDropdown(activeInput);

        }

    }, true);



    //==================================================
    // POSITION DROPDOWN
    //==================================================

    function positionDropdown(input) {

        if (!dropdown || !input) return;

        const rect = input.getBoundingClientRect();

        dropdown.style.minWidth = rect.width + "px";

        dropdown.style.left =
            (window.scrollX + rect.left) + "px";

        dropdown.style.top =
            (window.scrollY + rect.bottom + 8) + "px";

    }

    //==================================================
    // SHOW / HIDE
    //==================================================

    function showDropdown(input) {

        activeInput = input;

        positionDropdown(input);

        dropdown.style.display = "block";

    }

    function hideDropdown() {

        dropdown.style.display = "none";

    }
    //==================================================
    // INIT
    //==================================================

    function init() {

    createDropdown();

    renderCollections();

    document
        .querySelectorAll(".header-search__input")
        .forEach(input => {

            // Focus
            input.addEventListener("focus", () => {

                if (input.value.trim() === "") {

                    showDropdown(input);

                }

            });

            // Typing
            input.addEventListener("input", () => {

                if (input.value.trim().length > 0) {

                    hideDropdown();

                } else {

                    showDropdown(input);

                }

            });

            // Blur
            input.addEventListener("blur", () => {

                // Small delay so clicking a dropdown item still works
                setTimeout(() => {

                    hideDropdown();

                }, 150);

            });

            // ESC key
            input.addEventListener("keydown", (event) => {

                if (event.key === "Escape") {

                    hideDropdown();

                }

            });

        });

        // Click outside
        document.addEventListener("click", (event) => {

            if (!dropdown) return;

            const clickedInput = event.target.closest(".header-search__input");

            const clickedDropdown = event.target.closest(".ankur-search-dropdown");

            if (!clickedInput && !clickedDropdown) {

                hideDropdown();

            }

        });

    }



    if (document.readyState === "loading") {

        document.addEventListener(
            "DOMContentLoaded",
            init
        );

    } else {

        init();

    }

})();